import React from "react";

import useBuildCustomer from "../../../hooks/useBuildCustomer";
import useCurrentCustomerStore from "../../../stores/CustomerStore";

import { saveCustomer } from "../../../api/CustomerAPI";
import { showApiError } from "../../../utils/errorRoutingUtils";
import { useFormContext } from "react-hook-form";
import { saveSuccessAlert, saveFailAlert } from "../../../utils/alertUtils";
import { useFromUser } from "../../../stores/LocalStorageHelper";
import {
	buildCurrentAddress,
	buildMailingAddress,
	hasValidFields,
} from "./validAddressUtil";

import shallow from "zustand/shallow";
import useUserPrivileges from "../../settings/subFeatures/settingsTabs/userManagement/useUserPrivileges";

// Returns a button. When clicked, updates existing customer in the database
const UpdateCustomerButton = ({ isHeader = false }) => {
	// Local storage
	const dealerID = useFromUser("dealerID");
	const locationID = useFromUser("locationID");
	const privileges = useUserPrivileges();

	// Customer information stored and retrieved from the store
	const customer = useBuildCustomer();

	// Customer store
	const {
		storeCurrentAddress,
		storeMailingAddress,
		editMailAddress,
		editCurrentAddress,
		insurance,
		editInsurance,
	} = useCurrentCustomerStore(
		(state) => ({
			storeCurrentAddress: state.currentAddress,
			storeMailingAddress: state.mailingAddress,
			editMailAddress: state.editMailingAddress,
			editCurrentAddress: state.editCurrentAddress,
			insurance: state.insurance,
			editInsurance: state.editInsurance,
		}),
		shallow
	);

	// Calls the save customer endpoint
	const save = (data) => {
		const p = privileges();
		if (!p.customerSave) {
			saveFailAlert("User does not have permission to save customer");
			return;
		}
		const message = "All required or all empty";

		const currentAddress = buildCurrentAddress(
			data,
			dealerID,
			locationID,
			storeCurrentAddress.ID
		);
		const mailingAddress = buildMailingAddress(
			data,
			dealerID,
			locationID,
			storeMailingAddress.ID
		);
		const validCurrentAddress = hasValidFields(currentAddress);
		const validMailingAddress = hasValidFields(mailingAddress);

		if (!validCurrentAddress || !validMailingAddress) {
			if (!validCurrentAddress) {
				methods.setError("currentCity", { message });
				methods.setError("currentState", { message });
				methods.setError("currentZip", { message });
				//methods.setError("currentCounty", { message });
				methods.setError("currentOwnership", { message });
			}

			if (!validMailingAddress) {
				methods.setError("mailCity", { message });
				methods.setError("mailState", { message });
				methods.setError("mailZip", { message });
				//methods.setError("mailCounty", { message });
			}

			return;
		}

		const updatedInfo = {
			customer,
			insurance,
			currentAddress,
			mailingAddress,
		};

		saveCustomer(updatedInfo).then(
			(res) => {
				const savedCurrentAddress = res.data.content.currentAddress;
				const savedMailingAddress = res.data.content.mailingAddress;
				const savedInsurance = res.data.content.insurance;
				editCurrentAddress(savedCurrentAddress);
				editMailAddress(savedMailingAddress);
				editInsurance(savedInsurance);
				saveSuccessAlert();
			},
			(err) => {
				console.log(err);
				if (!err.isGeneralError) {
					showApiError(err, saveFailAlert);
				}
			}
		);
	};

	const methods = useFormContext();

	return (
		<>
			{isHeader ? (
				<div
					className="btn btn-success float-button  hi-z-index"
					onClick={methods.handleSubmit(save)}
				>
					<i className="nc-icon nc-check-2" /> Save
				</div>
			) : (
				<div
					className="btn btn-success float-button  hi-z-index"
					onClick={methods.handleSubmit(save)}
				>
					<i className="nc-icon nc-check-2" /> Save
				</div>
			)}
		</>
	);
};

export default UpdateCustomerButton;
